import { FiCheck } from "react-icons/fi";

const UnSelectedCircle = () => (
    <FiCheck size={"1.5em"} className="bg-secondary text-secondary opacity-50 rounded-circle p-1" />
);

export default UnSelectedCircle;
